import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import StagingConfigForm from "../StagingConfigForm/StagingConfigForm";
import {createStagingConfig} from '../../../actions/actionStaging';

class CreateStagingConfig extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Staging Config</strong>
                                </CardHeader>
                                <StagingConfigForm
                                    createStagingConfig={this.props.createStagingConfig}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            staging_configs: state.staging.staging_configs || [],
        }),
dispatch =>
    ({
        createStagingConfig: (data) => dispatch(createStagingConfig(data))
    }))(CreateStagingConfig);

